export default function convertToArrayAndFlatten(object: object) {
    return Object.values(object).flat((Infinity))
}